import styled, { css } from "styled-components";
import { parseSizeToken, useDesignTokens } from "@boi/react-design-tokens";
import { type AlertSeverity } from "@boi/components-core";

type ContainerProps = {
  $severity: AlertSeverity;
};

export const Container = styled.div<ContainerProps>`
  ${({ $severity }) => {
    const { tokens } = useDesignTokens();
    const { inlineAlert } = tokens;

    return css`
      display: grid;
      grid-template-columns: auto 1fr;
      gap: ${inlineAlert.gap};
      color: ${inlineAlert.color[$severity]};

      svg {
        width: ${inlineAlert.icon.width};
        height: ${inlineAlert.icon.height};
      }
    `;
  }}
`;

type IconWrapperProps = {
  $severity: AlertSeverity;
};

export const IconWrapper = styled.div<IconWrapperProps>`
  ${({ $severity }) => {
    const { tokens } = useDesignTokens();
    const { inlineAlert } = tokens;

    const height = parseSizeToken(inlineAlert.iconWrapper.height);

    return css`
      display: grid;
      place-content: center;
      height: ${height};

      & [data-primary-color] {
        color: ${inlineAlert.icon.primaryColor[$severity]};
      }

      & [data-secondary-color] {
        color: ${inlineAlert.icon.secondaryColor[$severity]};
      }
    `;
  }}
`;
